export default __webpack_public_path__ + "static/gender-nuetral-4f20e3e9848c581ea12b9e5b3e6808f6.svg";